/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/application_flow';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveApplicationFlowRequest": {
                    "fields": {
                      "applicationFlowId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fieldsToInclude": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "RetrieveApplicationFlowResponse": {
                    "fields": {
                      "applicationFlow": {
                        "type": ".squareup.sfs.external.models.ApplicationFlow",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "failedLegalEntitiesIds": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "sspRequestToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveApplicationFlowRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveApplicationFlowRequest @ squareup/sfs/external/services/application_flow/retrieve_application_flow.proto at 9:1
 */
export const RetrieveApplicationFlowRequest = $root.lookupType('squareup.sfs.external.service.RetrieveApplicationFlowRequest');
fixType(RetrieveApplicationFlowRequest, {
  applicationFlowId: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveApplicationFlowRequest);
/**
 * SOURCE RetrieveApplicationFlowResponse @ squareup/sfs/external/services/application_flow/retrieve_application_flow.proto at 22:1
 */
export const RetrieveApplicationFlowResponse = $root.lookupType('squareup.sfs.external.service.RetrieveApplicationFlowResponse');
fixType(RetrieveApplicationFlowResponse);
Builder.createAndAttachToType(RetrieveApplicationFlowResponse);